import {TEnumerationValue} from '../../Shared/Util/enumeration';

const InputType = {
    UP: 'up',
    DOWN: 'down',
    LEFT: 'left',
    RIGHT: 'right',
    SELECT: 'select',
    BLUR: 'blur',
} as const;

type TInputType = TEnumerationValue<typeof InputType>;

export {InputType as default, type TInputType};
